/**
 * Emit hosts for the `personalization` analytics group — 2 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { SegmentActionName, SegmentObjectName } from '@/models/analytics/segment-names';

// Personalization
export function trackPersonalizationTurnedOff(
  from?: 'note' | 'document' | 'opt_in_panel'
) {
  trackLegacyEvent({
    name: SegmentObjectName.Personalization,
    props: {
      action: SegmentActionName.PersonalizationTurnedOff,
      from: from,
    },
  });

  // V2 — personalization_updated
  track({
    event_name: TrackingEventName.PersonalizationUpdated,
    props: {
      update_action: 'personalization_turned_off',
      source: from,
    },
  });
}

export function trackPersonalizationTurnedOn(
  from?: 'note' | 'document' | 'opt_in_panel'
) {
  trackLegacyEvent({
    name: SegmentObjectName.Personalization,
    props: {
      action: SegmentActionName.PersonalizationTurnedOn,
      from: from,
    },
  });

  // V2 — personalization_updated
  track({
    event_name: TrackingEventName.PersonalizationUpdated,
    props: {
      update_action: 'personalization_turned_on',
      source: from,
    },
  });
}
